import FAQArticle from "../models/FAQArticle";
import FAQSearchResult from "../models/FAQSearchResult";
import FAQArticleMapper from "./FAQArticle.mapper";

export default class FAQSearchResultMapper {
    public static map(data: any) : FAQSearchResult {
        const result = new FAQSearchResult();
        result.numberOfTotalResults = data.TotalNumberOfSearchResults;
        result.results = data.Articles.map((art: any) => { return new FAQArticleMapper().map(art)} );

        return result;
    }
}